var _defs, _path, _polygon, _path2, _path3, _polygon2, _g, _path4, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #dcddde;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #faa527;\n      }\n\n      .st4 {\n        fill: #222;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.3,29l-6.2-3.6s-.4-.3-1.2-.3-1.2.3-1.2.3l-23.8,13.7v8.5s32.4-18.6,32.4-18.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "231.3 38.6 205.9 52.3 205.9 39.9 231.3 27.3 231.3 38.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216,42.1c-1.2,0-2.7.6-3,2.8l1.5.5c.2-.7.6-1.2,1.5-1.2s1.6.6,1.6,1.7h-3c-2,0-3,1.1-3,3.4v.5l1.7-.9c0-.8.4-1,1.4-1h.4l4-2.1c-.1-2.4-1.3-3.7-3-3.7h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.2,13.1c-1.4-.8-13.9-8-13.9-8,0,0-.5-.4-1.3-.4s-1.3.3-1.3.3l-22.7,13.1s-1.1.6-1.1,1.8v7.3l23.8-13.8s.5-.3,1.1-.3,1.1.3,1.1.3l15.5,8.9v-7.4s0-1.1-1.4-2l.2.2ZM240.7,12.6v1.1c-.1.1-.3.2-.4.1l-1.4-.7s-.1-.1-.1-.2v-1.1c.1-.1.3-.2.4-.1l1.4.7s.1.1.1.2Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "231.3 39.8 205.9 53.5 205.9 39.9 231.3 28.5 231.3 39.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.9,47.7v-8.5l23.8-13.7s.4-.3,1.2-.3.3,0,.4,0v-1.7h-.4c-.7,0-1.1.4-1.1.4l-23.8,13.7v-8.5l23.6-13.6s.5-.5,1.3-.5.3,0,.4,0v-1.6h-.3c-.6,0-1.1.3-1.1.3l-23.8,13.8v-7.3c0-1.2,1.1-1.8,1.1-1.8l22.7-13.1s.5-.3,1.3-.3.2,0,.2,0v-14.2l-27.7,11.5v51.4l27.7-13.7v-6.7l-25.3,14.6-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.8,5.1l-22.7,13.1s-1.1.6-1.1,1.8v7.3l23.8-13.8s.5-.3,1.1-.3.2,0,.3,0V4.8h-.2c-.8,0-1.3.3-1.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.7,25.5l-23.8,13.7v8.5l25.3-14.6v-7.9h-.4c-.8,0-1.2.3-1.2.3h0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M246.6,23.6l-14.7-8.5s-.2-.2-1-.2-1.3.5-1.3.5l-23.6,13.6v2.2l23.8-13.7s.5-.4,1.1-.4,1,.2,1,.2l12.8,7.5,2-1.2h-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.3,26.7l-9.4-5.3s-.2-.2-1-.2-1.3.5-1.3.5l-23.6,13.6v2.2l23.8-13.7s.5-.4,1.1-.4,1,.2,1,.2l7.5,4.3,2-1.2h-.1Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.6,42.1c0-4.2,1.8-6.3,5.6-6.3h5.5c-.1-2-1.3-3.2-3-3.2s-2.5.9-2.8,2.2l-2.8-.9c.6-3.9,3.3-5.1,5.5-5.1,3.4,0,5.6,2.7,5.6,7.5v3.2h-8.1c-2,0-2.5.5-2.5,2.5v6h-3v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,42.7h1c3,0,4.4-1.2,4.4-4s-.1-1.6-.3-2.6l-.5-3.4,2.8-.4.4,2.4c.1.7.2,1.4.3,2h2.3v3l-.8.8h-1.6c-.6,3.7-3,6.1-7,6.1h-1v-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.7,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.4,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.1,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.8,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.5,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.2,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.9,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.6,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.3,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98,37.4l.8-.8h1.7c3.8,0,5.8-.1,8.7-1.5l.9-.5h0c0-.1-4-1-4-1l-3.8-.9v1.9h-2.9v-1.9c0-2.4,1-3.5,3.1-3.5s1,.1,2.6.5l4.9,1.3c1.3.4,3,.6,4.5.6h.5v3.8h-1.8c0,.9.5,1.3,1.8,1.3h.8v3l-.8.8c-2.5,0-3.9-1.1-4.2-3.5h-.1c-4.4,3.1-6.9,3.5-10.1,3.5h-2.5v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115,37.4l.8-.8h1.1c1.3,0,1.6-.5,1.6-1.5v-13.4h3v13.4c0,3.6-1.2,5.3-4.6,5.3h-1.9v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.6,21.7h3v18.7h-3v-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.6,42.7h1c3,0,4.4-1.2,4.4-4s-.1-1.6-.3-2.6l-.5-3.4,2.8-.4.4,2.4c.1.7.2,1.4.3,2h2.3v3l-.8.8h-1.6c-.6,3.7-3,6.1-7,6.1h-1v-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.2,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.9,37.4l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.6,37.4l.8-.8h1.7c3.8,0,5.8-.1,8.7-1.5l.9-.5h0c0-.1-4-1-4-1l-3.8-.9v1.9h-2.9v-1.9c0-2.4,1-3.5,3.1-3.5s1,.1,2.6.5l4.9,1.3c1.3.4,3,.6,4.5.6h.5v3.8h-1.8c0,.9.5,1.3,1.8,1.3h.8v3l-.8.8c-2.5,0-3.9-1.1-4.2-3.5h-.1c-4.4,3.1-6.9,3.5-10.1,3.5h-2.5v-3ZM149.9,44.2c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.6,37.4l.8-.8h.8c1.4,0,2-.6,2-1.8v-3.6h2.8v3.6c0,1.2.6,1.8,1.8,1.8h1v3l-.8.8c-2.7,0-4-1.1-4.5-3.4h-.2c-.5,2.4-1.5,3.4-3.7,3.4v-3ZM160.8,27.5c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7ZM164.8,27.5c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.7,39c-.8,1-1.9,1.4-3.7,1.4v-3l.8-.8c1.3,0,1.7-.3,2.1-1.3l.7-1.7c.9-2.1,2.2-3.9,4.6-3.9s4.8,2.7,4.8,7.1v.7l-2.4,3.6-6.8-2.1ZM173.1,35.5l5.1,1.5v-.3c0-2-1.1-3.2-2.7-3.2s-1.9.6-2.3,1.8v.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.221094efb40398e09547c882813315e5.svg";
export { ForwardRef as ReactComponent };